import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "contents", "children", "className", "breakpoint"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useRef, useState } from "react";
import Div from "../../Div";
import { extendedSystemStylesProps } from "@mixins";
import { useElementWidth } from "hooks";
import { layoutStyledSystemKeys, gridStyledSystemKeys, listItemWidth, ScrollButton, StyledGrid } from "./carousel.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function R1CX_1(_ref) {
  var id = _ref.id,
    contents = _ref.contents,
    children = _ref.children,
    className = _ref.className,
    breakpoint = _ref.breakpoint,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIdx = _useState2[0],
    setActiveIdx = _useState2[1];
  var containerRef = useRef();
  var gridRef = useRef();
  var containerWidth = useElementWidth(containerRef);
  var itemsInView = containerWidth ? Math.floor(containerWidth / listItemWidth) : 0;
  var pages = itemsInView > 0 ? Math.ceil(children.length / itemsInView) : 0;
  var activePage = itemsInView > 0 ? Math.floor(activeIdx / itemsInView) : 0;
  var offset = -(itemsInView * listItemWidth * activePage);
  useEffect(function () {
    var handleFocus = function handleFocus(e) {
      var list = e.srcElement.offsetParent.children;
      for (var i = 0; i < list.length; i++) {
        if (list[i].contains(e.target)) {
          setActiveIdx(i);
          break;
        }
      }
    };
    var gridRefCopy = gridRef.current;
    gridRefCopy.addEventListener("focusin", handleFocus);
    return function () {
      return gridRefCopy === null || gridRefCopy === void 0 ? void 0 : gridRefCopy.removeEventListener("focusin", handleFocus);
    };
  }, []);
  return /*#__PURE__*/_jsxs(Div, _objectSpread(_objectSpread({
    className: "slider",
    position: "relative",
    overflow: "hidden",
    ref: containerRef
  }, extendedSystemStylesProps(layoutStyledSystemKeys, rest)), {}, {
    children: [activePage > 0 ? /*#__PURE__*/_jsx(ScrollButton, {
      id: "".concat(id, "-prev-items"),
      className: "prev",
      "aria-hidden": "true",
      "aria-label": "Scrolla bak\xE5t",
      onClick: function onClick() {
        return setActiveIdx((activePage - 1) * itemsInView);
      }
    }) : null, /*#__PURE__*/_jsx(StyledGrid, _objectSpread(_objectSpread({
      id: id,
      ref: gridRef,
      gridTemplateColumns: "repeat(".concat(contents.length, ", 1fr)"),
      breakpoint: breakpoint,
      className: className,
      offset: offset
    }, extendedSystemStylesProps(gridStyledSystemKeys, rest)), {}, {
      children: children
    })), activePage < pages - 1 ? /*#__PURE__*/_jsx(ScrollButton, {
      id: "".concat(id, "-next-items"),
      className: "next",
      "aria-hidden": "true",
      "aria-label": "Scrolla fram\xE5t",
      onClick: function onClick() {
        return setActiveIdx((activePage + 1) * itemsInView);
      }
    }) : null]
  }));
}